import React, { useEffect, useState } from "react";
import Footer from "../../components/Footer/Footer";
import Product from "../../components/Product/Product";
import ProductContent from "../../components/ProductContent/ProductContent";

import { ProductService } from "../../APIs/index";

import { Helmet } from "react-helmet";
import Header from "../../components/Header/Header";
import { Products } from "../ProductPage/ProductPage";


const Flavours: React.FC<any> = () => {
  const [products, setProducts] = useState<any[]>([]);

  const [filteredProducts, setFilteredProducts] = useState<Products[]>([]);
  const [screenSize, setScreenSize] = useState(getCurrentDimension());
  const [selectedCategory, setSelectedCategory] = useState("all");
  function getCurrentDimension() {
    return {
      width: window.innerWidth,
      height: window.innerHeight,
    };
  }

  function toUrlSlug(text: string) {
    const decoded = decodeURIComponent(text);
    const hyphenated = decoded.replace(/\s+/g, "-");
    return hyphenated;
  }

  const fetchProductData = async () => {
    try {
      const response = await ProductService.getAllProducts();
      if (response.data) {
        const filteredProducts = response.data.filter(
          (product) => product.product_type === "flavour"
        );
        setFilteredProducts(filteredProducts);
        setProducts(filteredProducts);
      } else {
        console.error("Error fetching products:", response.error);
      }
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  const productCaterogyDisplay = () => {
    if (selectedCategory === "ALL") {
      return products;
    } else {
      return products.filter(
        (product) => product.category === selectedCategory
      );
    }
  };

  useEffect(() => {
    if (products.length <= 0) {
      fetchProductData();
    }
  }, [products.length]);

  useEffect(() => {
    let products = productCaterogyDisplay();
    setFilteredProducts(products);
  }, [selectedCategory]);

  useEffect(() => {
    const updateDimension = () => {
      setScreenSize(getCurrentDimension());
    };
    window.addEventListener("resize", updateDimension);

    return () => {
      window.removeEventListener("resize", updateDimension);
    };
  }, [screenSize]);

  const FilterBar = () => (
    <div className="w-fit flex flex-row md:flex-row md:gap-10 gap-3 rounded-full bg-white px-10 py-2 items-center text-[10px]">
      <span>Filter by:</span>
      <button
        onClick={() => setSelectedCategory("ALL")}
        className={`cursor-pointer flex items-center justify-center py-2  ${
          selectedCategory === "ALL"
            ? "text-white rounded-full bg-[#75A7AD] p-5"
            : ""
        }`}>
        <span>ALL</span>
      </button>
      <button
        onClick={() => setSelectedCategory("PEPSI")}
        className={`cursor-pointer flex items-center justify-center py-2  ${
          selectedCategory === "PEPSI"
            ? "text-white rounded-full bg-[#75A7AD] p-5"
            : ""
        }`}>
        <span>PEPSI</span>
      </button>
      <button
        onClick={() => setSelectedCategory("CLASSIC")}
        className={`cursor-pointer flex items-center justify-center py-2  ${
          selectedCategory === "CLASSIC"
            ? "text-white rounded-full bg-[#75A7AD] p-5"
            : ""
        }`}>
        <span>CLASSIC</span>
      </button>
      <button
        onClick={() => setSelectedCategory("ZERO")}
        className={`cursor-pointer flex items-center justify-center py-2  ${
          selectedCategory === "ZERO"
            ? "text-white rounded-full bg-[#75A7AD] p-5"
            : ""
        }`}>
        <span>ZERO</span>
      </button>
      <button
        onClick={() => setSelectedCategory("FRUITS")}
        className={`cursor-pointer flex items-center justify-center py-2 ${
          selectedCategory === "FRUITS"
            ? "text-white rounded-full bg-[#75A7AD] p-5"
            : ""
        }`}>
        <span>FRUITS</span>
      </button>
    </div>
  );

  const capitalizeFirstLetter = (str: string) => {
    return str.replace(/\b\w/g, (char) => char.toUpperCase());
  };
  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          {"Sparkling Water Flavours - Sparkling Water Syrup | SodaStream SA"}
        </title>
        <meta
          name="description"
          content={
            "Discover SodaStream’s sparkling water syrup flavours & beverage mixes. Make your classic soda drink at home."
          }
        />
        <link rel="canonical" href="https://www.sodastream.co.za/flavours" />
        <meta
          name="keywords"
          content="home water carbonation system,
           home water carbonation system south africa, sparkling water machine for home"
        />

        <meta name="avg-search-volume" content="10 10 40" />

        <meta
          name="search-intent"
          content="Informational, Commercial, Commercial"
        />
      </Helmet>
      <Header
        desktopHeight="70vh"
        title="Sparkling Water Flavours"
        textBackground="FLAVOURS"
        backgroundImg="http://res.cloudinary.com/brabenjos/image/upload/v1743230260/sodastream/1743230259879.jpg"
      />

      <div className="relative w-full mt-[-13%]">
        <div className="flex flex-col items-center justify-center w-full">
          {/* Filter bar with simplified conditions */}
          <div className={screenSize.width > 1060 ? "mt-[3%]" : ""}>
            <FilterBar />
          </div>

          <div className="mt-5 w-full">
  {/* Grid with 1 column on mobile, 2 columns on small tablets, 3 on md, and 4 on lg */}
  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-6 lg:gap-10 px-2 md:px-6 lg:px-10">
    <div className="col-span-1 sm:col-span-2 md:col-span-1 hidden md:block">
      <Product>
        <p className="text-[#75A7AD] text-start text-lg md:text-xl lg:text-[23px] p-4 md:p-10 lg:p-20 font-bold">
          YOUR DREAM FLAVOURS
        </p>
      </Product>
    </div>

    {filteredProducts.map((product, index) => (
      <div key={index}>
        <Product>
          <ProductContent
            productLink={`/product/${toUrlSlug(
              product.productlinkname
            )}`}
            cta="VIEW DETAILS"
            title={capitalizeFirstLetter(product.shorten_name || "")}
            image={product.image}
            product={product}
            price={product.price || 0}
          />
        </Product>
      </div>
    ))}
  </div>
</div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Flavours;
